import { useEffect } from 'react'
import * as React from 'react'
import { useCurrentWorkspaceId } from 'hooks/useCurrentWorkspaceId'
import { useAuth } from 'hooks/UseAuth'

import { setReportUser } from 'utils/error'

interface Props {
  children: React.ReactChild
}

export const SentryAdditionalInfo = (props: Props) => {
  const { children } = props
  const auth = useAuth()
  const currentWorkspaceId = useCurrentWorkspaceId()

  useEffect(() => {
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    setReportUser(auth?.id!, auth?.email!, currentWorkspaceId)
  }, [auth, currentWorkspaceId])

  return <React.Fragment>{children}</React.Fragment>
}
